/**
 * Testimonials Data
 * Customer reviews and testimonials
 */
const assetsUrl = `${window.template_root}/src/public/`;

export const testimonials = [
  {
    id: "1",
    headline: "Stubborn weight is just coming off!",
    review:
      "I wasn't expecting miracles but I'm down 7 lbs in about 6 weeks and I didn't really change much else! I'm eating a little better but nothing crazy, I just feel less heavy if that makes sense.",
    name: "Diane R.",
    image: `${assetsUrl}img/drops-reviews-2.jpg`,
  },
  {
    id: "2",
    headline: "My stomach feels so much better",
    review:
      "I've dealt with that awful end-of-day bloat for years where my stomach looks completely different by 6pm than it did at 8am. Started taking this about 3 weeks ago and the difference is honestly wild. I'm not perfectly flat or anything but that puffy, tight feeling after dinner is mostly gone. My jeans actually fit the same all day now!",
    name: "Karen M.",
    image: `${assetsUrl}img/drops-reviews-1.jpg`,
  },
  {
    id: "3",
    headline: "It also improved my skin",
    review:
      "Bought this for the bloating but the skin thing caught me off guard. I've had this dull, congested look for a couple years now, kind of grayish? My aesthetician even commented that my skin looks brighter at my last appointment.",
    name: "Patricia L.",
    image: `${assetsUrl}img/drops-reviews-3.jpg`,
  },
  {
    id: "4",
    headline: "I’m snacking less now",
    review:
      "The biggest change for me has been the cravings. I used to hit a wall around 3pm every single day and go straight for chocolate or cookies. That's calmed way down. I still want something sweet sometimes but it's not that desperate NEED anymore. I'm snacking less overall which has probably helped me drop a few pounds too.",
    name: "Michelle T.",
    image: `${assetsUrl}img/drops-reviews-4.jpg`,
  },
  {
    id: "5",
    headline: "No more low energy",
    review:
      "It's been about a month and I genuinely have more energy throughout the day and not the jittery kind that coffee gives you. And seeing the numbers on the scale go down makes me so happy too!!",
    name: "Linda S.",
    image: `${assetsUrl}img/drops-reviews-5.jpg`,
  },
  {
    id: "6",
    headline: "Finally a fix for puffiness",
    review:
      "My face and midsection always looked puffy especially in the morning. I thought it was just an age thing I had to accept. A month into using Naori and the puffiness has gone down noticeably. My rings fit better, my face looks less swollen when I wake up. I drink it in a glass of water first thing and it's actually kind of refreshing with the peppermint.",
    name: "Janet W.",
    image: `${assetsUrl}img/drops-reviews-6.jpg`,
  },
  {
    id: "7",
    headline: "So much better than doing a cleanse!",
    review:
      "I've tried every detox out there. The teas, the juice cleanses, the crazy 7-day things that basically have you living in the bathroom. This is nothing like that. It's just a little dropper in the morning and you go about your day. I actually stuck with this one past the first week which says a lot because I usually quit everything else.",
    name: "Susan B.",
    image: `${assetsUrl}img/drops-reviews-7.jpg`,
  },
  {
    id: "8",
    headline: "Really glad I gave it a chance",
    review:
      "Well it's been two months now and I ordered my second bottle. Stomach is flatter, my skin looks better, I have more energy and I'm not reaching for snacks all evening. I actually feel good about how I look again!",
    name: "Barbara G.",
    image: `${assetsUrl}img/drops-reviews-8.jpg`,
  },
];

export default testimonials;
